export var StackableRowVariantType;
(function (StackableRowVariantType) {
    /**
     * @deprecated
     * `DEFAULT` variant is deprecated. Use `REGULAR` variant instead
     */
    StackableRowVariantType["DEFAULT"] = "DEFAULT";
    StackableRowVariantType["REGULAR"] = "REGULAR";
    StackableRowVariantType["EMPTY"] = "EMPTY";
})(StackableRowVariantType || (StackableRowVariantType = {}));
//# sourceMappingURL=stackableRowVariantType.js.map